export enum TokenDispatcherAction {
  requestToken = 'REQUEST_TOKEN',
}
